<pep-message-dialog [title]="'Speichern'"
  [showCancelButton]="false"
  (pushClose)="closeDialog()">
  <div class="row">
    Es bestehen ungespeicherte Änderungen.
  </div>

  <!-- Action Buttons on Footer -->
  <ng-container ngProjectAs="actionOnFooter">
    <div ngbTooltip="Die ungespeicherten Änderungen können nicht gespeichert werden, da sie unvollständig sind!"
      container="body" tooltipClass="myTooltip" [disableTooltip]="isSaveable">
      <button mat-button (click)="saveChanges()" [disabled]="!isSaveable">
        <mat-icon>check</mat-icon> Speichern
      </button>
    </div>
    @if (showDiscardButton) {
      <button mat-button (click)="discardUnsavedChanges()">
        <mat-icon>undo</mat-icon> Verwerfen
      </button>
    }
    @if (showCancelButton) {
      <button mat-button (click)="closeDialog()">
        <mat-icon>close</mat-icon> Abbrechen
      </button>
    }

  </ng-container>

</pep-message-dialog>
